import { FleetUUIDs } from '../enums';
import { useFleet } from './useFleet';
import { useHasAccess } from './useHasAccess';

const fleetsWithAssetManagement = [FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot];

export const useAssetManagement = (): boolean => {
  const fleet = useFleet();
  if (!fleet) {
    return false;
  }

  return fleetsWithAssetManagement.includes(fleet.uuid as FleetUUIDs);
};

export const useAssetManagementForCustomer = (): boolean => {
  const hasAccess = useHasAccess();
  const isAssetManagement = useAssetManagement();

  if (isAssetManagement && !hasAccess) {
    return true;
  }
  return false;
};

export const useCanViewLargeLicensePlate = (): boolean => {
  const fleet = useFleet();
  const hasAccess = useHasAccess();
  if (hasAccess) {
    return true;
  }

  if (fleet.uuid === FleetUUIDs.MBTA || fleet.uuid === FleetUUIDs.MBTAPrePilot) {
    return false;
  }

  return true;
};
